import { deleteExaminationsId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { OrderPaths } from "Order/Routes/Routing";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { toast } from "sonner";

const examinationMutationsResource = Resources.base.examination.mutations;

export const useDeleteOrderExaminationMutation = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	return useMutation({
		mutationFn: processResponse((examinationId: number) =>
			deleteExaminationsId(examinationId),
		),
		onError: (error) => {
			console.error(
				`${t(examinationMutationsResource.deleteExaminationError)}:`,
				error,
			);
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: orderKeys.detail(orderId) }),
				queryClient.invalidateQueries({
					queryKey: orderKeys.examinations(orderId),
				}),
			]);
			toast.success(t(examinationMutationsResource.deleteExaminationSuccess));
			navigate(OrderPaths.Edit.path(orderId));
		},
	});
};
